import React, { useState, type ReactElement, useEffect } from 'react'
import { ReactComponent as ImportIcon } from '../../assets/import_icon.svg'
import './preOrder.css'
import AdminButton from '../utils/adminButton/AdminButton'
import Modal from '../utils/modal/Modal'
import { type ProductType } from '../../utils/types'
import InfoModal from '../utils/infoModal/InfoModal'
import AddPreOrders from './addPreOrder/addPreOrder'
import ListPreOrder from './listPreOrder/ListPreOrder'
import preOrderService from '../../services/preOrderService'

const PreOrders = (): ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isImportModalOpen, setIsImportModalOpen] = useState(false)
  const [preOrders, setPreOrders] = useState<ProductType[]>([])
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
  const [modalText, setmodalText] = useState<any>()
  const [shouldCloseModal, setShouldCloseModal] = useState(false)

  const onDrop = (e: React.DragEvent<HTMLLabelElement>): void => {
    e.preventDefault()
    const files = e.dataTransfer.files
    if (files.length > 0) {
      setSelectedFile(files[0])
    }
  }

  const onDragOver = (e: React.DragEvent<HTMLLabelElement>): void => {
    e.preventDefault()
  }

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    if (event.target.files) {
      setSelectedFile(event.target.files[0])
    }
  }

  const handleUpload = async (): Promise<void> => {
    if (selectedFile) {
      const formData = new FormData()
      formData.append('file', selectedFile)

      try {
        await preOrderService.importPreOrders(formData)
        setIsInfoModalOpen(true)
        setmodalText('Pre-orders importés avec succès')
        setSelectedFile(null)
        await handleAddPreOrder()
        setShouldCloseModal(true)
      } catch (error: any) {
        setIsInfoModalOpen(true)
        setShouldCloseModal(false)
        let errorMessage =
          "Une erreur est survenue lors de l'importation des preOrders."

        if (error?.isAxiosError) {
          const errorMessages = error.response?.data?.errors
          if (Array.isArray(errorMessages)) {
            errorMessage = errorMessages.join('\n')
          } else {
            errorMessage = error.response?.data?.message || errorMessage
          }
        } else {
          errorMessage = error.message || errorMessage
        }
        const errorMessagesArray = errorMessage.split('\n')

        const formattedErrorMessages = errorMessagesArray.map((msg, index) => (
          <div style={{ padding: '5px' }} key={index}>
            {msg}
          </div>
        ))

        setmodalText(formattedErrorMessages)
      }
    }
  }
  const handleExport = async (): Promise<void> => {
    try {
      await preOrderService.downloadExportedPreOrders()
    } catch (error: any) {
      console.error('Failed to export data ', error)
    }
  }

  const handleAddPreOrder = async (): Promise<void> => {
    try {
      const response = await preOrderService.getAllPreOrders()
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      setPreOrders(response)
    } catch (error) {
      console.error('Failed to fetch audiences:', error)
    }
  }

  useEffect(() => {
    const fetchPreOrders = async (): Promise<void> => {
      try {
        const response = await preOrderService.getAllPreOrders()
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        setPreOrders(response)
      } catch (error) {
        console.error('Failed to fetch pre-orders:', error)
      }
    }
    void fetchPreOrders()
  }, [])

  return (
    <div className='preOrders-container'>
      <AdminButton
        onClick={() => {
          setIsModalOpen(true)
        }}
      >
        CREER PRE-ORDER
      </AdminButton>
      <AdminButton
        onClick={() => {
          setIsImportModalOpen(true)
        }}
      >
        IMPORT PRE-ORDER
      </AdminButton>
      <AdminButton onClick={handleExport}>EXPORT PRE-ORDER</AdminButton>

      <ListPreOrder preOrdersList={preOrders} />
      <Modal
        isOpen={isModalOpen}
        title='Ajouter un nouveau pre-order'
        onClose={() => {
          setIsModalOpen(false)
        }}
      >
        <AddPreOrders
          closeModal={() => {
            setIsModalOpen(false)
          }}
          onAddPreOrder={handleAddPreOrder}
        />
      </Modal>
      <Modal
        isOpen={isImportModalOpen}
        title='Import Pre-Order'
        onClose={() => {
          setIsImportModalOpen(false)
          setSelectedFile(null)
        }}
      >
        <div className='flex flex-col items-center justify-center space-y-4'>
          <label
            className={`label ${
              selectedFile ? 'border-green-500' : 'border-gray-300'
            }`}
            htmlFor='file_upload_2'
            onDragOver={onDragOver}
            onDrop={onDrop}
          >
            <span className='span-container'>
              <ImportIcon
                className={`icon ${
                  selectedFile ? 'text-green-600' : 'text-gray-600'
                }`}
              />
              <span
                className={`font-medium ${
                  selectedFile ? 'text-green-600' : 'text-gray-600'
                }`}
              >
                {selectedFile ? selectedFile.name : 'Importer un fichier .xlsx'}
              </span>
            </span>
            <input
              className='hidden'
              name='file_upload_2'
              onChange={handleFileChange}
              type='file'
              id='file_upload_2'
              multiple
            />
          </label>
          <AdminButton
            className='import-preOrders-button'
            onClick={handleUpload}
          >
            Importer
          </AdminButton>
        </div>
      </Modal>

      <InfoModal
        isOpen={isInfoModalOpen}
        title='Import Pre-Orders'
        message={modalText}
        onClose={() => {
          setIsInfoModalOpen(false)

          if (shouldCloseModal) {
            setIsImportModalOpen(false)
          }
        }}
      />
    </div>
  )
}

export default PreOrders
